import { useState } from "react";

export function usePageHeaderEditEntityButton() {
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    return { anchorEl, setAnchorEl, open: Boolean(anchorEl), popoverId: anchorEl ? "simple-popover" : undefined };
}
